import React from 'react';

import Banner from './Banner';
import Meet from './Meet';
import OurService from './OurService';
import Molding from './Molding';
import Specialized from './Specialized';
import Reqprodcte from './Reqprodcte';
import Partservice from './Partservice';
// import Maintance from './Maintance';
// import Apply from './Apply';

const Home = () => {
  return (
    <div>
       <Banner />
            <Meet />
            <OurService />
            <Molding />
            <Specialized />
            <Reqprodcte />
              <Partservice />
            {/* <Maintance /> */}
            {/* <Apply /> */}
           
    </div>
  );
};

export default Home;
